var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notification",class:'is-' + _vm.variant},[_c('button',{staticClass:"delete",on:{"click":function($event){return _vm.close()}}}),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }